var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fb_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.5H2.25A2.25 2.25 0 000 3.75v16.5a2.25 2.25 0 002.25 2.25h6.434v-7.14H5.73V12h2.954V9.439c0-2.914 1.734-4.523 4.39-4.523 1.273 0 2.603.227 2.603.227v2.86H14.21c-1.444 0-1.895.896-1.895 1.815V12h3.224l-.515 3.36h-2.709v7.14h6.434A2.25 2.25 0 0021 20.25V3.75a2.25 2.25 0 00-2.25-2.25z",
    fill: "#555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fb_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v24H0z"
  })))));
}

export default SvgFb;